// src/api/config.ts
import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;
const apiOrigin = process.env.REACT_APP_API_ORIGIN_HEADER!;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-origin': apiOrigin,
  },
});

// Middleware, for every request (token)
apiClient.interceptors.request.use((request) => {
  const token = localStorage.getItem('token');
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`;
  }
  return request;
}, (error) => {
  return Promise.reject(error);
});

// Middleware for status 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
